import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },
  field: {
    width: '100%',
    height: 46,
    borderRadius: 5,
    backgroundColor: theme.custom.grey[6],
  },
  registrationNumber: {
    marginTop: 8,
  },
  successMessage: {
    width: '100%',
    height: 66,
    marginTop: 12,
    borderRadius: 5,
    backgroundColor: theme.custom.grey[6],
  },
  ownerBirthDate: {
    marginTop: 27,
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    height: 24,
    marginLeft: -2,
  },
  registrationNumberNotKnown: {
    marginTop: 9,
  },
  acceptAllConsents: {
    marginTop: 13,
  },
  checkbox: {
    flex: '0 0 auto',
    width: 24,
    height: 24,
    marginRight: 12,
    borderRadius: 4,
    backgroundColor: theme.custom.grey[6],
  },
  checkboxLabel: {
    flex: '1 1 auto',
    maxWidth: 280,
    height: 17,
    borderRadius: 4,
    backgroundColor: theme.custom.grey[6],
  },
  acceptAllLabel: {
    flex: '1 1 auto',
    maxWidth: 420,
    height: 20,
    borderRadius: 4,
    backgroundColor: theme.custom.grey[6],
  },
  consents: {
    marginTop: 14,
    padding: '7px 0',
    borderRadius: 12,
    backgroundColor: theme.custom.grey[8],
  },
  consentRow: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '5px 10px',
  },
  consentRowRegulations: {
    height: 34,
  },
  consentRowCepik: {
    height: 44,
  },
  consentRowMarketing: {
    height: 61,
  },
  consentLines: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    paddingTop: 2,
  },
  consentLine: {
    height: 12,
    borderRadius: 4,
    backgroundColor: theme.custom.grey[6],
  },
  consentLineLast: {
    width: '55%',
  },
  submitButton: {
    height: 46,
    marginTop: 20,
    borderRadius: 100,
    backgroundColor: theme.custom.grey[6],
  },
}));
